import { useMutation, MutationHookOptions } from '@companyon/graphql';
import { UNLINK_CARD_MUTATION } from '../../schema/mutations/unlinkCard';

export function useUnlinkCardMutation(options?: MutationHookOptions) {
  return useMutation(UNLINK_CARD_MUTATION, options);
}
